import React from 'react';
import { NavLink } from 'react-router-dom';
import { FileText, FolderTree, Tags, MessageSquare, PenLine, Settings2 } from 'lucide-react';

const TABS = [
  { to: '/articles', label: 'مقالات', icon: FileText, end: true },
  { to: '/articles/new', label: 'نوشتن مقاله', icon: PenLine, end: true },
  { to: '/articles/categories', label: 'دسته‌بندی‌ها', icon: FolderTree, end: true },
  { to: '/articles/tags', label: 'برچسب‌ها', icon: Tags, end: true },
  { to: '/articles/comments', label: 'دیدگاه‌ها', icon: MessageSquare, end: true },
  { to: '/articles/settings', label: 'متن‌ها و لینک‌ها', icon: Settings2, end: true },
];

/** نوار تب‌های بخش مدیریت وبلاگ */
const BlogSectionNav: React.FC<{ title: string; description?: React.ReactNode; action?: React.ReactNode }> = ({ title, description, action }) => (
  <div className="mb-6 space-y-4">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-2xl font-black text-gray-900">{title}</h1>
        {description && <div className="mt-1 text-sm leading-7 text-gray-600">{description}</div>}
      </div>
      {action}
    </div>
    <nav className="-mx-1 flex gap-1 overflow-x-auto rounded-2xl border border-gray-200 bg-white p-1 shadow-sm" aria-label="بخش‌های وبلاگ">
      {TABS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `inline-flex shrink-0 items-center gap-2 rounded-xl px-4 py-2 text-sm font-bold transition-colors ${
              isActive ? 'bg-[#4a2e68] text-white shadow-sm' : 'text-gray-600 hover:bg-violet-50 hover:text-[#4a2e68]'
            }`
          }
        >
          <Icon className="h-4 w-4" aria-hidden />
          {label}
        </NavLink>
      ))}
    </nav>
  </div>
);

export default BlogSectionNav;
